import { shallowEqual, useSelector } from 'react-redux';
import type { StoreState } from '../types';

export const useEqualSelector = <TReturn, TStoreState = StoreState>(
  selector: (state: TStoreState) => TReturn,
) => useSelector<TStoreState, TReturn>(selector, shallowEqual);
